import axios from "axios";
import { useEffect, useState } from "react";
import { useMoralis } from "react-moralis";
import { useParams } from "react-router-dom";
import { PresaleABI } from "../../data/ABI";
import { inChainId } from '../../data/chainId';
import { PresaleContract } from "../../utility/contractAddress";
import { ClaimComponent, ElementLoader, IdoCompnent, LockComponent } from "../../components";
const apiUrl = process.env.REACT_APP_API_URL;

const LoaderEl = () => <ElementLoader />

const Ido = () => {
  const params = useParams()
  const address = params.address;
  const [detail, setDetail] = useState({})
  const [salingState, setSalingState] = useState('')
  const [fundingGoalAmount, setFundingGoalAmount] = useState(0)
  const [soldTokenAmount, setSoldTokenAmount] = useState(0)

  const [isLoading, setIsLoading] = useState(false)
  const [detailUser, setDetailUser] = useState({})
  const { user, Moralis } = useMoralis()
  const [timer, setTimer] = useState({})
  const getUserInfo = async () => {
    const web3 = await Moralis.enableWeb3();
    if (user) {
      const walletAddress = await user.get("ethAddress");
      const chainIdDec = await web3.eth.getChainId();
      if (parseInt(inChainId) === parseInt(chainIdDec)) {
        // let stabcontract = new web3.eth.Contract(PresaleABI, detail.tokenAddress);
        let stabcontract = new web3.eth.Contract(PresaleABI, PresaleContract);
        const infouser = await stabcontract.methods.fundersProperty(walletAddress).call();
        setDetailUser(infouser)
      } else {
        console.log("Connect to BSC Network!");
      }
    }
  }

  async function endTime() {
    const web3 = await Moralis.enableWeb3();
    const chainIdDec = await web3.eth.getChainId();
    if (parseInt(inChainId) === parseInt(chainIdDec)) {
      let stabcontract = new web3.eth.Contract(PresaleABI, PresaleContract);
      // let stabcontract = new web3.eth.Contract(PresaleABI, detail.tokenAddress);
      const endsale = await stabcontract.methods.endTime().call();
      const uniqueTimeEnd = endsale;
      setInterval(() => {
        const uniqueTimeNow = Math.floor(new Date().getTime() / 1000);
        if (uniqueTimeNow < uniqueTimeEnd) {
          const BATAS = new Date(uniqueTimeEnd * 1000).getTime();
          const SEKARANG = new Date().getTime();
          var JARAK = BATAS - SEKARANG;

          var days = Math.floor(JARAK / (1000 * 60 * 60 * 24));
          var hours = Math.floor((JARAK % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((JARAK % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((JARAK % (1000 * 60)) / 1000);
          setTimer({
            days, hours, minutes, seconds
          })
        }
      }, 1000);
    } else {
      console.log("Connect to BSC Network!");
    }
  }

  async function sellingState() {
    const web3 = await Moralis.enableWeb3();
    const chainIdDec = await web3.eth.getChainId();
    if (parseInt(inChainId) === parseInt(chainIdDec)) {
      let stabcontract = new web3.eth.Contract(PresaleABI, PresaleContract);
      // let stabcontract = new web3.eth.Contract(PresaleABI, detail.tokenAddress);
      const sellstate = await stabcontract.methods.sellingState().call();
      setSalingState(sellstate)
    } else {
      console.log("Connect to BSC Network!");
    }
  }

  async function soldToken() {
    const web3 = await Moralis.enableWeb3();
    const chainIdDec = await web3.eth.getChainId();
    if (parseInt(inChainId) === parseInt(chainIdDec)) {
      // let stabcontract = new web3.eth.Contract(PresaleABI, detail.tokenAddress);
      let stabcontract = new web3.eth.Contract(PresaleABI, PresaleContract);
      const sold =
        (await stabcontract.methods.soldToken().call()) / 1000000000;
      setSoldTokenAmount(sold)
    } else {
      console.log("Connect to BSC Network!");
    }
  }

  async function fundingGoal() {
    const web3 = await Moralis.enableWeb3();
    const chainIdDec = await web3.eth.getChainId();
    if (parseInt(inChainId) === parseInt(chainIdDec)) {
      let stabcontract = new web3.eth.Contract(PresaleABI, PresaleContract);
      // let stabcontract = new web3.eth.Contract(PresaleABI, detail.tokenAddress);
      const goal =
        (await stabcontract.methods.fundingGoal().call()) / 1000000000;
      console.log(goal);
      setFundingGoalAmount(goal)
    } else {
      console.log("Connect to BSC Network!");
    }
  }


  const getDetail = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/list/detail/${address}`);
      if (response.status === 200) {
        setDetail(response.data.data)
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log(error.message)
    }
  }
  useEffect(() => {
    getDetail()
    getUserInfo()
    endTime()
    sellingState()
    soldToken()
    fundingGoal()
  }, [])
  return (
    <>
      {
        isLoading ? (<LoaderEl />) : (
          <IdoCompnent
            detailUser={detailUser}
            salingState={salingState}
            detail={detail}
            timer={timer}
            fundGoal={fundingGoalAmount}
            soldToken={soldTokenAmount}
          />
        )
      }
      {
        user && <LockComponent detail={detail} />
      }
      {
        user && <ClaimComponent detail={detail} />
      }

    </>
  )
}

export default Ido
